import { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import BeatLoader from 'react-spinners/BeatLoader';

export default function CloseJob(props) {
    const [show, setShow] = useState(false);
    const [closing, setClosing] = useState(false);
    const handleClose = () => {setShow(false); props.setState(false)}
    const handleShow = () => setShow(true);
    useEffect(() => {
        setShow(props.state)
    }, [props])
    function Close(props){
        setClosing(true)
        axios.post('/jobs/api/v1/job/close.php', {
            id: props.id
        }).then((response) => {
            if(response.data.Message === 'OK'){
                setClosing(false)
                handleClose();
                props.setState(false)
            }
        })
    }
    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Close Job Vaccancy</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to close this job vaccancy? <b>All non-accepted applicants will be automatically rejected!</b></Modal.Body>
                <Modal.Footer>
                    <button type="button" className="jamescape-blue-button" onClick={handleClose}>Cancel</button>
                    <button type="button" className="jamescape-red-button" onClick={() => Close(props)}>{closing ? <BeatLoader color={'#002F78'}></BeatLoader> : "Close Job"}</button>
                </Modal.Footer>
            </Modal>
        </>
    );
}